module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "background": "white",
      "padding": "10px"
    }
  }, [(_vm.resp == 'OK') ? _c('h2', [_vm._v("Az új jelszavadat kiküldtük az email címedre.")]) : _vm._e(), _vm._v(" "), (_vm.resp == 'FAIL') ? _c('h2', [_vm._v("Hibás vagy lejárt token.")]) : _vm._e()])])]), _vm._v(" "), _c('footer-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ecae867","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/NewPass.vue
// module id = 203
// module chunks = 0 2